import { ApiTypes } from "types"

export interface LinkFunnelRow {
  label: string
  value: number
  percent?: string
  color: string
  soft?: boolean
  width: number
}

export interface LinkFunnel {
  installRate: string
  rows: LinkFunnelRow[]
}

const formatPercent = (rate: number) => `${Math.round(rate * 100)}%`

export const buildLinkFunnel = ({
  install_rate,
  link_opens_qr_scans,
  submitted,
  confirmed_by_you,
  installed,
}: ApiTypes.Model.ReferralAgentDashboardLinkQrFunnel): LinkFunnel => {
  const opens = link_opens_qr_scans.count
  const widthOf = (count: number) => (opens > 0 ? (count / opens) * 100 : 0)

  return {
    installRate: `${Math.round(install_rate * 1000) / 10}% install rate`,
    rows: [
      { label: "Link opens & QR scans", value: opens, color: "var(--brand)", width: widthOf(opens) },
      {
        label: "Submitted",
        value: submitted.count,
        percent: formatPercent(submitted.conversion_rate),
        color: "var(--status-success)",
        width: widthOf(submitted.count),
      },
      {
        label: "Confirmed by you",
        value: confirmed_by_you.count,
        percent: formatPercent(confirmed_by_you.conversion_rate),
        color: "var(--surface-inverse)",
        width: widthOf(confirmed_by_you.count),
      },
      {
        label: "Installed",
        value: installed.count,
        percent: formatPercent(installed.conversion_rate),
        color: "var(--status-success)",
        soft: true,
        width: widthOf(installed.count),
      },
    ],
  }
}
